export enum Operator {
  Prev,
  Next,
}
